export const getCurrentAccountSelector = state => state.modern.currentAccount
export const getCurrentUserSelector = state => state.modern.currentUser
export const getCurrentItem = state => state.modern.currentItem
